export const NAV_MODE = { CHAT: 'chat', PULSE: 'pulse' }
